import { useTranslation } from "react-i18next";
import { useAuth } from "@/hooks/useAuth";
import { Clock, LogOut, RefreshCw } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";

/**
 * Full-screen blocking screen shown to users whose registration
 * has not yet been approved by a Super-Admin.
 * Auto-polls profile every 30s via useAuth's TanStack Query.
 */
export function RegistrationPendingScreen() {
  const { t } = useTranslation();
  const { signOut, reloadUserData } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <Clock className="h-8 w-8 text-primary" />
          </div>
          <CardTitle>{t("registrationPending.title")}</CardTitle>
          <CardDescription>{t("registrationPending.description")}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Alert>
            <Clock className="h-4 w-4" />
            <AlertDescription>{t("registrationPending.info")}</AlertDescription>
          </Alert>

          <Button variant="outline" className="w-full" onClick={() => reloadUserData()}>
            <RefreshCw className="mr-2 h-4 w-4" />
            {t("registrationPending.refreshButton")}
          </Button>

          <Button variant="ghost" className="w-full" onClick={signOut}>
            <LogOut className="mr-2 h-4 w-4" />
            {t("registrationPending.signOutButton")}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
